module.exports = __webpack_public_path__ + "img/New Mexico.428789eb.png";